import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { HrSystemDisconnectConfirmationComponent } from './hrSystem.disconnect.confirm.component';

@NgModule({
  declarations: [
    HrSystemDisconnectConfirmationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
  ],
  exports: [
    HrSystemDisconnectConfirmationComponent
  ]
})
export class hrSystemDisconnectConfirmationModule { }
